import React, { Component } from 'react'
import Client from '../ContentFul';



const PortfolioContext = React.createContext();

class PortfolioProvider extends Component {
    state = {
        projects:[], // add all rooms
        featuredProjects:[], // all rooms has a featured value is true,
        forSaleProjects:[],
        forSaleCoverProject:[],
        loading:true,
        otherProjects:[]
    };


    getData = async () => {
        try {
            let response = await Client.getEntries({content_type:"projects"});
            let projects = this.formatAPI(response.items);

            // check if this is new Project or not
            let featuredProjects = projects.filter(item => item.featured === true);
            let forSaleProjects = projects.filter(item => item.forSale === true);
            let forSaleCoverProject = projects.filter(item => item.forSale === true && item.saleCover === true);
            let otherProjects = projects.filter(item => item.featured === false);
            this.setState({otherProjects,projects,featuredProjects,forSaleProjects,forSaleCoverProject,loading:false})
        } catch (error) {
            console.log(error);
        }
    }

    formatAPI = items => {
        let tempProjects = items.map(item => {
            let id = item.sys.id;
            let images = item.fields.images.map(image => image.fields);
            let project = {...item.fields,images,id}
            return project;
        })
        return tempProjects;
    }

    getSlug = slug => {
        let tempProjects = [...this.state.projects];
        const project = tempProjects.find(project => project.slug === slug);
        return project;
    }
    componentDidMount(){
        this.getData();
        this.getSlug();
    }
    render() {
        return (
            <div>
                {/* <PortfolioContext.Provider value={this.state}>  the same thiing if use speread operator*/}
                <PortfolioContext.Provider value={{...this.state,getData:this.getData,getSlug:this.getSlug}}>
                    {this.props.children}
                </PortfolioContext.Provider>
            </div>
        )
    }
}


export {PortfolioProvider,PortfolioContext}
